import { Badge } from './badge';
import { cn } from '../lib/cn';

/**
 * Generic enum-to-color mapper used by feature / epic / story / sprint / kb statuses.
 * Falls through to `outline` when the status isn't recognised.
 */
const palette: Record<string, string> = {
  // common terminal states
  done: 'border-transparent bg-emerald-500/20 text-emerald-200',
  shipped: 'border-transparent bg-emerald-500/20 text-emerald-200',
  closed: 'border-transparent bg-neutral-500/20 text-neutral-300',
  deprecated: 'border-transparent bg-rose-500/20 text-rose-200',
  rejected: 'border-transparent bg-rose-500/20 text-rose-200',
  failed: 'border-transparent bg-rose-500/20 text-rose-200',
  abandoned: 'border-transparent bg-neutral-500/20 text-neutral-300',

  // approved / active
  approved: 'border-transparent bg-emerald-500/20 text-emerald-200',
  active: 'border-transparent bg-emerald-500/20 text-emerald-200',
  achieved: 'border-transparent bg-emerald-500/20 text-emerald-200',
  completed: 'border-transparent bg-emerald-500/20 text-emerald-200',

  // in flight
  in_progress: 'border-transparent bg-sky-500/20 text-sky-200',
  in_review: 'border-transparent bg-sky-500/20 text-sky-200',
  in_sprint: 'border-transparent bg-sky-500/20 text-sky-200',
  pr_open: 'border-transparent bg-sky-500/20 text-sky-200',
  spawned: 'border-transparent bg-sky-500/20 text-sky-200',
  planning: 'border-transparent bg-sky-500/20 text-sky-200',
  proposed: 'border-transparent bg-sky-500/20 text-sky-200',
  review: 'border-transparent bg-sky-500/20 text-sky-200',

  // waiting / draft / triage
  draft: 'border-transparent bg-neutral-500/20 text-neutral-300',
  pending: 'border-transparent bg-neutral-500/20 text-neutral-300',
  ready: 'border-transparent bg-amber-500/20 text-amber-200',
  triaged: 'border-transparent bg-amber-500/20 text-amber-200',
  epic_proposed: 'border-transparent bg-amber-500/20 text-amber-200',
  committed: 'border-transparent bg-amber-500/20 text-amber-200',
  carried_over: 'border-transparent bg-neutral-500/20 text-neutral-300',
  planned: 'border-transparent bg-neutral-500/20 text-neutral-300',
};

export function StatusBadge({ status, className }: { status: string; className?: string }) {
  return <Badge className={cn(palette[status] ?? '', className)} variant={palette[status] ? 'default' : 'outline'}>
    {status.replace(/_/g, ' ')}
  </Badge>;
}
